import React from 'react';
import { useSelector } from 'react-redux';
import { ZoneShapeType } from '@src/core/features/zones/entites';
import { ZoneCircle, ZonePolygon } from './shapes';
import { selectDisplayZones, useGetZonesQuery } from '@src/core/features/zones/redux';
import { ZonesControlProps } from './types';

const ZonesControl: React.FC<ZonesControlProps> = () => {
  const displayZones = useSelector(selectDisplayZones);
  const { data: zones = [], isLoading } = useGetZonesQuery();

  if (isLoading) return null;

  return (
    <React.Fragment>
      {displayZones && 
       <React.Fragment>
         {zones.map((zone) => {
           if (zone.shape === ZoneShapeType.CIRCLE) {
             return <ZoneCircle key={zone.id} zone={zone} />;
           }
           if (zone.shape === ZoneShapeType.POLYGON) {
             return <ZonePolygon key={zone.id} zone={zone} />;
           }
         })}
       </React.Fragment>
      }
    </React.Fragment>
  );
};

export default ZonesControl;